import { render, staticRenderFns } from "./ActivityBar.vue?vue&type=template&id=4dad0dd6"
import script from "./ActivityBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ActivityBar.vue?vue&type=style&index=0&id=4dad0dd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports